import { render, staticRenderFns } from "./AllocationsForDocument.vue?vue&type=template&id=176fe3ec&scoped=true&"
import script from "./AllocationsForDocument.vue?vue&type=script&lang=js&"
export * from "./AllocationsForDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176fe3ec",
  null
  
)

export default component.exports